import firebase from 'config/firebase';

export enum VerificationStatus {
  'NOT_VERIFIED' = 'NOT_VERIFIED',
  'VERIFYING' = 'VERIFYING',
  'VERIFIED' = 'VERIFIED',
}

export enum EmailVerificationStatus {
  'NOT_VERIFIED' = 'NOT_VERIFIED',
  'VERIFYING' = 'VERIFYING',
  'EMAIL_SENT' = 'EMAIL_SENT',
  'EMAIL_FAILED' = 'EMAIL_FAILED',
}
export interface BetaTestingProducts {
  cowriter: boolean | undefined;
  verificationStatus: VerificationStatus;
}

export type PersonalizationKeys = 'usecase' | 'educationLevel' | 'workType' | 'english';

export type PersonalizationInfo = {
  [key in PersonalizationKeys]?: string | Array<string>;
};

export interface User extends PersonalizationInfo {
  providerId?: string;
  displayName?: string | null;
  fullName?: string;
  email?: string | null;
  emailVerified?: boolean;
  creationTime?: string;
  lastSignInTime?: string;
  phoneNumber?: string | null;
  photoUrl?: string | null;
  uid?: string;
  userType?: string;
  bday?: string;
  isSubscribedToEmail?: boolean;
  referrer?: string;
  lang?: string;
  syncedWithDb?: boolean;
  feathers?: number;
  counts?: Record<string, number>;
  demographic?: string;
  englishSpeaker?: string;
  // intent?: string;
  ip?: string;
  emailSubscriptionStatus?: boolean;
  paymentMethod?: string;
  planLabel?: string;
  dollarValue?: string;
  premium?: boolean;
  isAuthenticated?: boolean;
  isLoading?: boolean;
  userID?: string;
  created?: boolean;
  count?: { [key: string]: string | number };
  providerData?: (typeof firebase.UserInfo | null)[];
  acceptedPremiumModesTnc?: boolean;
  skippedPersonalization?: boolean;
  isSubPaused?: boolean;
  isSubRenewing?: boolean;
  shownNps?: boolean;
  affiliatePartnerName?: string;
  subscriptionId?: string;
  customerId?: string;
  availedRefund?: boolean;
}

export type Provider = 'google' | 'facebook' | 'email';
